import {CSSProperties} from 'react';
import {SxProps} from '@mui/material';

// the styling for select main container
export const selectMainContainer: SxProps = {
  width: '100%',
  borderRadius: '25px',
  backgroundColor: '#FFFFFF',
};

// the styling for the input container
export const inputContainer: SxProps = {
  zIndex: 5,
  backgroundColor: '#FFFFFF',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '45px',
  borderRadius: '62px',
  boxShadow: '0px 4px 15px 0px rgba(0, 0, 0, 0.08)',
};

// the styling for the input icon container
export const inputIconContainer: SxProps = {
  width: '50px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingLeft: '15px',
};

// the styling for the end icon container
export const endIconContainer: SxProps = {
  width: '50px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingRight: '7px',
};

// the styling for down icon container
export const downIconContainer: SxProps = {
  backgroundColor: '#002C5810',
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
};

// the styling for the required icon container
export const requiredIconContainer: SxProps = {
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  width: '10px',
  height: '25px',
};

// the styling for the required icon
export const requiredIcon: SxProps = {
  color: '#DA1B1B',
};

// the styling for input component
export const input: CSSProperties = {
  backgroundColor: '#FFFFFF',
  border: 0,
  outline: 0,
  height: '40px',
  width: '100%',
  color: '#000000',
  fontFamily: 'Montserrat, sans-serif',
  fontSize: 13,
  fontWeight: 500,
};

// the styling for options collapsed container
export const optionsCollapsedContainer: SxProps = {
  overflow: 'hidden',
  marginTop: '-45px',
  paddingTop: '45px',
  width: '100%',
  backgroundColor: 'transparent',
  borderRadius: '25px',
  maxHeight: '0px',
  transition: 'all 0.25s cubic-bezier(0, 1, 0, 1)',
};

// the styling for options expanded container
export const optionsExpandedContainer: SxProps = {
  overflow: 'hidden',
  marginTop: '-45px',
  paddingTop: '45px',
  width: '100%',
  backgroundColor: 'transparent',
  borderRadius: '25px',
  boxShadow: '0px 4px 15px 0px rgba(0, 0, 0, 0.08)',
  height: 'auto',
  maxHeight: '9999px',
  transition: 'all 0.25s cubic-bezier(1, 0, 1, 0)',
};

// the styling for options container
export const optionsContainer: SxProps = {
  width: '100%',
  padding: '15px 0px',
};

// the styling for option container
export const optionContainer: SxProps = {
  width: '100%',
  padding: '5px 25px',
  '&:hover': {
    cursor: 'pointer',
  },
};

// the styling for option text
export const optionText: SxProps = {
  color: '#000000',
  fontSize: '13px',
  fontWeight: 500,
  userSelect: 'none',
};
